<template>
  <div class="work-bench">
    <el-row style="width: 100%;height: 100%" :gutter="15">
      <el-col style="height: 100%" :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="left" style="margin-right:15px">
          <div class="bg left-top">
            <div class="part" @click="quickJump('1')">
              <span class="t-c">
                <img src="../../assets/images/workbench/shuziziyuan.png" alt="">
              </span>
              <span class="m-des mt-15">个人网盘</span>
            </div>

            <div class="part" @click="quickJump('2')">
              <span class="t-c">
                <img src="../../assets/images/workbench/tongxunlu.png" alt="">
              </span>
              <span class="m-des mt-15">通讯录</span>
            </div>

            <div class="part" @click="quickJump('3')">
              <span class="t-c">
                <img src="../../assets/images/workbench/yewushuju.png" alt="">
              </span>
              <span class="m-des mt-15">业务数据填报</span>
            </div>

            <div class="part" @click="quickJump('4')">
              <span class="t-c">
                <img src="../../assets/images/workbench/ziliaoxiazai.png" alt="">
              </span>
              <span class="m-des mt-15">资料下载</span>
            </div>

            <div class="part" @click="quickJump('5')">
              <span class="t-c">
                <img src="../../assets/images/workbench/tushujieyue.png" alt="">
              </span>
              <span class="m-des mt-15">图书借阅</span>
            </div>

            <div class="part" @click="quickJump('6')">
              <span class="t-c">
                <img src="../../assets/images/workbench/wodekaoqing.png" alt="">
              </span>
              <span class="m-des mt-15">我的考勤</span>
            </div>

            <div class="part" @click="quickJump('7')">
              <span class="t-c">
                <img src="../../assets/images/workbench/zhibanbiao.png" alt="">
              </span>
              <span class="m-des mt-15">值班表</span>
            </div>
          </div>

          <div class="left-middle">
            <div class="news-wrapper">
              <div class="bg approve-wrapper mb-13">
                <el-card class="box-card">
                  <div slot="header">
                    <span class="title">最新消息</span>
                    <span class="fr">
                    </span>
                  </div>

                  <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="通知公告" name="first">
                      <div class="card-content" v-loading="isLoading">
                        <template v-if="infoList && infoList.length > 0 || isLoading">
                          <div v-for="(item, index) in infoList" :key="index">
                            <div class="title-wrapper" style="padding: 5px 0;cursor: pointer;"
                              @click="getNoticeDetail(item)">
                              <span class="span-title"> {{ item.title  }}</span>
                              <span
                                class="f-r span-time">{{ item.createTimeStr.indexOf(':')!= -1 ? $common.formatDateString(item.createTimeStr, 'yyyy-MM-dd') : item.createTimeStr }}</span>
                            </div>
                            <!-- <div class="title-wrapper" style="padding: 10px 0;cursor: pointer;" @click="getNbdtDetail(item)">
                          <span class="span-title"> {{ item.content && item.content.articles && item.content.articles[0].title }}</span>
                        
                          <span class="f-r span-time" style="width: 130px;text-align: right">{{ $common.formatDateString(item.content.createTime, 'yyyy-MM-dd') }}</span>
                        </div> -->
                          </div>
                        </template>
                        <el-empty v-else :image="noDataImg" :image-size="65" style="padding: 0"
                          description="暂无数据"></el-empty>
                      </div>
                      <!-- <div class="card-content">
                    <collapse accordion>
                      <collapse-item v-for="(item, index) in infoList" @itemClck="getNoticeDetail(item)" :key="index" :name="index">
                        <template slot="title">
                          <div class="title-wrapper">
                            <span class="span-title"> {{ item.title }}</span>
                            <span class="f-r span-time">{{$common.formatDateString(item.createTimeStr, 'yyyy-MM-dd') }}</span>
                          </div>
                        </template>
                        <div>
                          <a-progress :text-inside="true" :stroke-width="20" :percentage="parseInt(item.ext2)" :percentage1="parseInt(item.ext1)"></a-progress>
                        </div>
                      </collapse-item>
                    </collapse>
                  </div> -->
                    </el-tab-pane>
                    <el-tab-pane label="辽博动态" name="second">
                      <div class="card-content" v-loading="isLoading">
                        <template v-if="nbdtList && nbdtList.length > 0 || isLoading">
                          <div v-for="(it, index) in nbdtList" :key="index">
                            <template v-if="it.content && it.content.newsItem.length > 0">
                              <div v-for="(item,dx) in it.content.newsItem" :key="dx">
                                <template>
                                  <div v-if="!item.isDeleted" class="title-wrapper"
                                    style="padding: 5px 0;cursor: pointer;" @click="getNbdtDetail(item)">
                                    <span class="span-title"> {{ item.title }}</span>
                                    <span class="f-r span-time"
                                      style="width: 130px;text-align: right">{{ $common.formatDateString(item.createTime, 'yyyy-MM-dd') }}</span>
                                  </div>
                                </template>
                              </div>
                            </template>
                          </div>
                        </template>
                        <el-empty v-else :image="noDataImg" :image-size="65" style="padding: 0"
                          description="暂无数据"></el-empty>
                      </div>
                    </el-tab-pane>
                  </el-tabs>

                  <div class="more" @click="getMoreNotice">查看更多</div>

                </el-card>
              </div>
              <div class="bg approve-wrapper">
                <el-card class="box-card">
                  <div slot="header">
                    <span class="title">审批</span>
                    <span class="fr">
                      <img class="img-add" @click="goApprove" src="../../assets/images/add.png" alt="">
                    </span>
                  </div>

                  <el-tabs v-model="activeName1" @tab-click="handleClick1">
                    <el-tab-pane :label="`待审批（${approveNum}）`" name="first">
                      <ul class="approve-ul" v-if="approveList && approveList.length > 0">
                        <li class="approve-li" @click="approveClick(item)" v-for="(item, index) in approveList"
                          :key="index">{{item.title}}</li>
                      </ul>
                      <el-empty v-else :image="noDataImg" :image-size="65" style="padding: 0"
                        description="暂无数据"></el-empty>
                    </el-tab-pane>
                    <el-tab-pane :label="`我发起（${approveByMeNum}）`" name="second">
                      <ul class="approve-ul" v-if="approveByMineList && approveByMineList.length > 0">
                        <li class="approve-li" @click="approveClick(item)" v-for="(item, index) in approveByMineList"
                          :key="index">{{item.title}}</li>
                      </ul>
                      <el-empty v-else :image="noDataImg" :image-size="65" style="padding: 0"
                        description="暂无数据"></el-empty>
                    </el-tab-pane>
                  </el-tabs>

                  <div class="more" @click="getMore"
                    v-if="(activeName1 =='first' && approveNum > 0) || (activeName1 =='second' && approveByMeNum > 0)">
                    查看更多</div>

                </el-card>
              </div>
            </div>

            <div class="dynamic-wrapper">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="title">部门动态</span>
                  <span class="fr" v-if="showBtn" @click="goPublish">
                    <img class="img-add" src="../../assets/images/add.png" alt="">
                  </span>
                </div>

                <div class="box-dynamic card-content">
                  <div v-if="dynamicDataList.length > 0">
                    <div class="dynamic-item" v-for="(item, index) in dynamicDataList" :key="index">
                      <div class="top">
                        <div class="avatar-wrapper">
                          <img class="avatar" :src="item.userImg || ''" alt :onerror="defaultHeadImg" />
                          <div class="des">
                            <p class="name">
                              {{ item.name }}
                            </p>
                          </div>
                        </div>

                      </div>

                      <div class="detail" style="margin-top: 8px">
                        <div>
                          <pre v-if="!item.isTotal">{{
                          item.dynamicContent | ellSplit(67)
                        }}</pre>
                          <pre v-if="item.isTotal">{{ item.dynamicContent }}</pre>
                        </div>
                        <span class="tag-total" v-if="
                          item.dynamicContent && item.dynamicContent.length > 67
                        " @click="item.isTotal = !item.isTotal">
                          <i>{{ item.isTotal ? '收起' : '全文' }}</i>
                        </span>
                      </div>

                      <el-row class="img-list mt-10" :gutter="10">
                        <viewer :images="item.picList">
                          <el-col :span="6" v-for="(it, i) in item.picList" :key="i">
                            <img class="g-pointer" :src="it" alt />
                          </el-col>
                        </viewer>
                      </el-row>

                      <div class="btns">
                        <div>
                          <span class="time">{{ item.createTimeDes }}</span>
                          <span class="delete" v-if="item.isDelete == 1" @click="deleteDynamic($event, item)">删除</span>
                        </div>
                        <div class="right1">
                          <div class="cmp-like">
                            <i class="cmp-icon-like" :class="[
                              'cmp-icon-like',
                              item.status === '2' ? 'active' : ''
                            ]" @click.stop="changeLike(item)"></i>
                          </div>

                          <div class="btn-comment ml-10" @click="handleComment(item)">
                            <img src="@images/btn-comment.svg" alt />
                          </div>
                        </div>
                      </div>

                      <div class="bottom" v-if="
                        (item.praise && item.praise.length) ||
                          (item.commentList && item.commentList.length)
                      ">
                        <div class="trangle"></div>
                        <div class="person-box" v-if="item.praise && item.praise.length" :class="{
                          'has-comment': item.commentList && item.commentList.length
                        }">
                          <img src="~@images/zan-active.svg" alt />
                          <label class="ell">
                            {{ item.praise }}
                          </label>
                        </div>

                        <ul class="comment-list">
                          <li v-for="(it, i) in item.commentList" :key="i">
                            <div>
                              <span class="light">{{ it.commenter }}</span>
                              <span v-show="it.answer">回复</span>
                              <span class="light" v-show="it.answer">{{
                              it.answer
                            }}</span>
                              ：{{ it.commentContent }}
                            </div>

                            <el-dropdown trigger="click" @command="handleOperate(item, it.commentId, $event)">
                              <span>
                                <i class="el-icon-more icon-common g-pointer"
                                  style="font-size: 12px; color: #575962"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="1">回复</el-dropdown-item>
                                <el-dropdown-item command="2" v-show="it.canDel === '1'">删除</el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <p class="m-des tc g-pointer" style="margin-top: 7px" @click="moreDynamic" v-if="!noMore">
                      加载更多
                    </p>
                    <p class="m-des tc g-pointer" style="margin-top: 7px" v-if="noMore">已全部加载</p>
                  </div>

                  <div class="g-no-data mb-30 mt-30" v-if="dynamicDataList.length === 0 && !listLoading">
                    <div class="no-data-bg"></div>
                    <p class="txt tc">暂无数据</p>
                  </div>
                </div>
              </el-card>
            </div>
          </div>

          <div class="left-bottom">
            <div class="box-process flex-1 bg">
              <el-card class="box-card">
                <div slot="header">
                  <span class="title">项目进度计划（{{proList.length}}）</span>
                  <span class="fr">
                  </span>
                </div>

                <div>
                  <div class="progress-wrapper" v-for="(item, index) in proList" :key="index">
                    <div class="progress-inner">
                      <el-progress :stroke-width="50" :percentage="item.percent"></el-progress>
                      <!-- <br /><span class="pro-type">{{item.proType}}</span> -->
                      <p class="pro-box"><span class="pro-name" :title="item.name">{{item.name}}</span></p>
                    </div>

                    <div class="day-wrapper">
                      <span>距离结项剩余</span><br />
                      <span class="day-content">{{item.dayRemain}}</span>天
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
            <div class="bg box-museum">
              <el-card class="box-card">
                <div slot="header">
                  <span class="title">馆藏文物</span>
                  <!-- <span class="fr">
                <i class="el-icon-plus"></i>
              </span> -->
                </div>

                <div v-if="collectionNum > 0">
                  <div class="chart-wrapper">
                    <div class="pie-chart" ref="chart2"></div>
                    <div class="total">
                      <img src="../../assets/images/museum.png" alt="">
                      <p class="p1">藏品数量</p>
                      <p class="p2">{{collectionNum}}</p>
                    </div>
                  </div>

                  <div class="chart-legend">
                    <div class="legend-item" v-for="(item, index) in pieLegend" :key="index">
                      <div class="legend-item-inner">
                        <span :style="{background: colors[index]}"></span>
                        <span>{{item.name}}</span>
                        <span>{{item.num}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <el-empty :image="noDataImg" :image-size="100" style="padding: 0" description="暂无藏品"></el-empty>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </el-col>

      <el-col style="height: 100%" :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="right">

          <div class="chart-wrapper">
            <div class="bg w-100 kl-box">
              <el-card class="chart1">
                <div slot="header">
                  <span class="title">线下参观客流</span>
                  <span class="fr">
                    <el-select v-model="timeType" @change="changeTour" placeholder="请选择">
                      <el-option v-for="item in timeArr" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                </div>

                <div v-if="tourFlag" :style="{height: tourFlag ? '168px':0}" ref="chart3"></div>

                <div v-else>
                  <el-empty :image="noDataImg" :image-size="100" style="padding: 0" description="暂无数据"></el-empty>
                </div>
                <div class="chart-info">
                  <div class="chart-item" v-for="(item, index) in tourList" :key="index" style="margin-right:11px">
                    <span class="span1">{{item.text}}</span>
                    <span class="span2">{{item.num}}</span>
                  </div>
                </div>
              </el-card>
            </div>

            <div class="bg w-100 sj-box">
              <el-card class="chart1">
                <div slot="header">
                  <span class="title">社教活动</span>
                  <span class="fr">
                    <el-select @change="changeActivity" v-model="activityType" placeholder="请选择">
                      <el-option v-for="item in activityTypeArr" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                </div>

                <div v-if="activityFlag" style="height: 100%" ref="chart4"></div>

                <div v-else>
                  <el-empty :image="noDataImg" :image-size="100" style="padding: 0" description="暂无数据"></el-empty>
                </div>
              </el-card>
            </div>

            <div class="bg w-100 zl-box">
              <el-card class="chart2">
                <div slot="header">
                  <span class="title">辽博展览</span>
                  <span class="fr">
                  </span>
                </div>
                <div class="chart-flex">
                  <div v-if="exhibitionFlag" class="exhibition-chart" ref="chart5"></div>
                  <div class="exhibition-chart" v-else>
                    <el-empty :image="noDataImg" :image-size="100" style="padding: 0" description="暂无数据"></el-empty>
                  </div>
                  <div class="exhibition-des">
                    <div style="margin-bottom: 28px;width: 150px" v-if="clzlList && clzlList.length > 0">
                      <h1>常设展览</h1>
                      <p v-for="(item, index) in clzlList" :key="index">
                        <span>{{item.name}}</span>
                        <!-- <span v-if="item.des">：{{item.des}}</span> -->
                      </p>
                    </div>

                    <div style="width: 150px" v-if="lszlList && lszlList.length > 0">
                      <h1>临时展览</h1>
                      <p v-for="(item, index) in lszlList" :key="index">
                        <span>{{item.name}}</span>
                        <!-- <span v-if="item.des">：{{item.des}}</span> -->
                      </p>
                    </div>
                  </div>

                </div>
              </el-card>
            </div>
          </div>

          <div class="others">
            <div class="weather-wrapper bg" style="height: 183px;margin-bottom:16px">
              <div class="weather-inner">
                <div class="weather-left">
                  <span class="tem">{{ realTemp }}°</span>
                  <span class="date" :class="classObject">{{humidity}}</span>
                </div>
                <div class="weather-right">
                  <span class="weather-img"><img v-if="weatherImg" :src="weatherImg" alt="" /></span>
                  <span class="week">{{weatherInfo}}</span>
                  <span class="tem-range">最高{{maxTemp}}° 最低{{minTemp}}°</span>
                </div>
              </div>

              <div class="weather-detail">
                <div class="detail-part" style="margin-right:9px">
                  <div class="detail-top">
                    <span><img src="../../assets/images/workbench/temperature.png" alt=""></span>
                    <span style="margin-left: 4px">体感温度</span>
                  </div>
                  <div class="detail-bottom">
                    <span>{{feelTemp}}°</span>
                  </div>
                </div>

                <div class="detail-part" style="margin-right:9px">
                  <div class="detail-top">
                    <span><img src="../../assets/images/workbench/humidity.png" alt=""></span>
                    <span style="margin-left: 4px">湿度</span>
                  </div>
                  <div class="detail-bottom">
                    <span>{{humidityInfo}}</span>
                  </div>
                </div>

                <div class="detail-part">
                  <div class="detail-top">
                    <span><img src="../../assets/images/workbench/wind.png" alt=""></span>
                    <span style="margin-left: 4px">风</span>
                  </div>
                  <div class="detail-bottom" style="font-size: 14px;margin-top:6px">
                    <span>{{direct}}{{power}}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="schedule-wrapper bg flex-1">
              <v-calendar @choseDay="clickDay"></v-calendar>
              <div class="schedule-inner">
                <div class="header">今日日程<span> <img class="img-add" @click="addSchedule"
                      src="../../assets/images/add.png" alt="" /></span></div>

                <div class="schedule-list" v-loading="scheduleFlag">
                  <template v-if="scheduleList && scheduleList.length > 0 || scheduleFlag">
                    <div class="schedule-item" v-for="(item, index) in scheduleList" @click="getScheduleDetail(item)"
                      :key="index">
                      <span class="line"></span>
                      <div class="schedule-inner-right">
                        <div class="schedule-top">
                          <div>
                            <span class="span1">{{item.startDatetime}}-{{item.endDatetime}}</span>
                            <span class="span2">{{item.schedulePlace}}</span>
                          </div>

                          <div class="icon" @click="delSchedule($event, item)">
                            <i class="el-icon-close" style="color: #306159"></i>
                          </div>
                        </div>
                        <div class="schedule-bottom">{{item.scheduleContent}}</div>
                      </div>
                    </div>
                  </template>
                  <el-empty v-else :image="noDataImg" :image-size="100" style="padding: 0"
                    description="暂无日程"></el-empty>
                </div>
              </div>
            </div>

            <div class="attendance-wrapper bg">
              <div class="header">我的考勤</div>
              <div class="content">
                <div class="part">
                  <span class="part-day">{{attendance.ljJB}}<span class="span1">小时</span></span>
                  <span class="part-desc">加班时长</span>
                </div>
                <div class="part">
                  <span class="part-day">{{attendance.syNJ}}<span class="span1">天</span></span>
                  <span class="part-desc">年假剩余天数</span>
                </div>
                <div class="part">
                  <span class="part-day">{{attendance.kyCX}}<span class="span1">小时</span></span>
                  <span class="part-desc">可串休</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog :title="operation == 'add' ?  '新建日程' : '编辑日程'" :visible.sync="dialogSchedule" width="30%"
      :before-close="handleClose">
      <el-form class="g-form-grid" ref="scheduleForm" :model="scheduleForm" label-width="120px" :rules="rules">
        <el-form-item label="是否全天 :" prop="isFull">
          <el-select v-model="scheduleForm.isFull" placeholder="请选择">
            <el-option v-for="item in fullArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="日程时间 :" prop="scheduleTime">
          <el-time-picker is-range v-model="scheduleTime" range-separator="至" start-placeholder="开始时间" format="HH:mm"
            value-format="HH:mm" end-placeholder="结束时间" placeholder="选择时间范围">
          </el-time-picker>
        </el-form-item>

        <!-- <el-form-item label="结束时间 :" prop="endDatetime">
          <el-date-picker v-model="scheduleForm.endDatetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item> -->

        <el-form-item label="重复类型 :" prop="repeatType">
          <el-select v-model="scheduleForm.repeatType " placeholder="请选择">
            <el-option v-for="item in repeatTypeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="地点 :" prop="schedulePlace">
          <el-input v-model="scheduleForm.schedulePlace" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="日程内容 :" prop="scheduleContent">
          <el-input type="textarea" v-model="scheduleForm.scheduleContent" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <dialogCreadDynamic ref="dialogCreadDynamic" @refresh="refreshDynamic"></dialogCreadDynamic>
    <approve-panel ref="approvePanel" :roleType="pageType" @refresh="getTodoList"></approve-panel>

  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

import dialogCreadDynamic from './dialog-create-dynamic'
import approvePanel from './../approve/dialog/approve-panel' // 审批面板

import collapse from '@cmp/collapse/collapse.vue'
import collapseItem from '@cmp/collapse/collapse-item.vue'
import aProgress from '@cmp/progress/progress.vue'
import Calendar from 'vue-calendar-component';
export default {
  components: {
    dialogCreadDynamic,
    aProgress,
    collapse,
    collapseItem,
    approvePanel,
    "v-calendar": Calendar
  },
  computed: {
    classObject: function () {
      let humidity = this.humidity
      return {
        green: humidity >= 0 && humidity <= 50,
        yellow: humidity >= 51 && humidity <= 100,
        orange: humidity >= 101 && humidity <= 150,
        red: humidity >= 151 && humidity <= 200,
        purple: humidity >= 201 && humidity <= 300,
        maroon: humidity > 300,

      }
    },
    ...mapGetters(["isFold"]),

  },
  data() {
    return {
      userid: "",
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      noDataImg: require('../../assets/images/no-data.svg'),
      activeName: 'first',
      activeName1: 'first',
      scheduleFlag: false,
      pageType: "",
      approveNum: 0,
      approveByMeNum: 0,
      listLoading: false,
      tourFlag: false,
      dynamicDataList: [],
      colors: ['#306159', '#F3CC89', '#3C4059', '#AA7C65', '#F0F0F0'],
      collectionNum: 0,
      pieLegend: [],
      clzlList: [],
      lszlList: [],
      tourList: [],
      activityType: '1',
      activityTypeArr: [{ label: '举办场次', value: '1' }, { label: '参与人数', value: '2' }],
      timeArr: [{ label: '日', value: '1' }, { label: '月', value: '2' }, { label: '年', value: '3' }],

      proList: [],
      showBtn: false, //按钮权限
      listQuery: {
        currentPage: 1,
        size: 10
      },
      levelList: [],
      infoList: [],
      nbdtList: [],
      museumOptions: {},
      passengerOptions: {},
      isLoading: false,
      operation: '',
      approveList: [], //待审批列表
      approveByMineList: [], //我发起审批
      realTemp: '', //当前温度
      feelTemp: '', // 体感温度
      humidity: '',
      humidityInfo: '', //湿度
      week: '', // 星期
      minTemp: 0,
      maxTemp: 0,
      direct: '',//风向
      power: '',//风力等级
      weatherImg: "",
      weatherInfo: "",
      scheduleForm: {},
      dialogSchedule: false,
      activityFlag: false,
      exhibitionFlag: false,
      rules: {},
      timeType: '1',
      scheduleDate: '',
      scheduleTime: [this.$common.formatDateString(new Date(), 'hh:mm'), this.$common.formatDateString(new Date(), 'hh:mm')],
      scheduleList: [], //今日日程
      repeatTypeArr: [{ id: '0', name: '不重复' }, { id: '1', name: '天' }, { id: '2', name: '周' }, { id: '3', name: '月' }, { id: '4', name: '年' }],
      fullArr: [{ id: '0', name: '否' }, { id: '1', name: '是' }],
      value1: "",
      attendance: {
        ljJB: '0',
        syNJ: '0',
        kyCX: '0'
      }
    }
  },

  methods: {
    // 发动态
    goPublish() {
      this.$refs.dialogCreadDynamic.init()
    },

    // 快速跳转
    quickJump(type) {
      let url = ""
      switch (type) {
        case '1':
          url = '/resources/net-disk'
          break
        case '2':
          url = '/home/address-book'
          break
        case '3':
          url = '/approve/personal-summary'
          break
        case '4':
          url = '/home/data-download'
          break
        case '5':
          url = '/books/book'
          break
        case '6':
          url = '/approve/view-person'
          break
        case '7':
          url = '/home/watch-list'
          break
      }

      this.$router.push({
        path: url
      })
    },

    // 最新消息tab
    handleClick(tab, event) {
      this.activeName = tab.name
      this.isLoading = true
      if (tab.name == 'first') {
        this.getInfoList()
      } else {
        this.$http.get('/applet/index/nbdt', {
          page: 0,
          count: 5
        }).then(res => {
          if (res.success) {
            this.isLoading = false
            this.nbdtList = res.result.items
          }
        })
      }
    },

    // 审批tab
    handleClick1(tab, event) {
      this.activeName1 = tab.name
    },
    getDict() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: [
            'collection_level',
          ]
        })
        .then(res => {
          if (res.success) {
            let data = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.levelList = firstArr.concat(data['collection_level'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 通知公告详情
    getNoticeDetail(item) {
      let pathInfo = this.$router.resolve({
        path: '/approve/notice-detail',
        query: {
          obj: encodeURIComponent(JSON.stringify(item))
        }
      })
      window.open(pathInfo.href, '_blank');
    },

    getNbdtDetail(item) {
      if (item.url) {
        window.open(item.url, '_blank');
      }
    },

    getAttendance() {
      this.$http
        .get('/attendanceStat/list', {
          userId: this.$store.state.user.userid
        })
        .then(res => {
          if (res.success) {
            this.tableData = res.result
            if (this.tableData.length > 0) {
              this.attendance = this.tableData[0]
            }
          }
        }).catch(err => {
        })

    },


    // 删除动态
    deleteDynamic(e, obj) {
      let evt = e || window.event
      evt.stopPropagation()

      let param = { id: obj.dynamicId }
      this.$common.confirm(
        {
          title: `是否删除该部门动态？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.workbench.delDynamic(param).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getDynamicDataList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 审批页面
    goApprove() {
      this.$router.push({
        path: '/approve/start-approve'
      })
    },

    // 审批查看更多
    getMore() {
      let url = "", state = ""
      if (this.activeName1 == 'first') {
        url = "/approve/process-pending"
        state = "pending"
      } else {
        url = "/approve/process-mystart"
        state = "mystart"
      }

      this.$router.push({
        path: url,
        query: { state: state }
      })
    },

    getMoreNotice() {
      let url = "", query = {}
      if (this.activeName == 'first') {
        url = "/home/notice-list"
      } else {
        url = "/home/nbdt-list"
      }

      this.$router.push({
        path: url,
        query: query
      })
    },

    // 审批详情
    approveClick(row) {
      if (this.activeName1 == 'first') {
        this.pageType = "pending"
      } else {
        this.pageType = "mystart"
      }
      this.$refs.approvePanel.init(row)
    },

    // 切换日程
    clickDay(day) {
      let parseDay = this.$common.parseTime(day, '{y}-{m}-{d}')
      this.scheduleFlag = true
      this.scheduleDate = parseDay
      this.getScheduleList()
    },

    // 创建日程
    addSchedule() {
      this.operation = "add"
      this.dialogSchedule = true
      this.scheduleTime = [this.$common.formatDateString(new Date(), 'hh:mm'), this.$common.formatDateString(new Date(), 'hh:mm')]
      this.scheduleForm = {}
    },

    // 获取日程详情
    getScheduleDetail(obj) {
      this.operation = "edit"
      this.scheduleTime = []
      this.$api.workbench.getScheduleDetail({ id: obj.scheduleId }).then(res => {
        if (res.success) {
          if (res.result) {
            this.dialogSchedule = true
            this.scheduleForm = res.result
            if (res.result.startDatetime) {
              this.scheduleTime.push(res.result.startDatetime)
            } else {
              this.scheduleTime.push(this.$common.formatDateString(new Date(), 'hh:mm'))
            }

            if (res.result.endDatetime) {
              this.scheduleTime.push(res.result.endDatetime)
            } else {
              this.scheduleTime.push(this.$common.formatDateString(new Date(), 'hh:mm'))
            }
          }
        }
      })
    },

    // 删除日程
    delSchedule(e, obj) {
      let evt = e || window.event
      evt.stopPropagation()

      this.$common.confirm(
        {
          title: `是否删除该日程？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.workbench.delSchedule({ id: obj.scheduleId }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getScheduleList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    handleClose() {
      this.dialogSchedule = false
      this.scheduleTime = []
      this.scheduleForm = {}

    },

    // 创建日程
    handleSubmit() {
      if (this.scheduleTime && this.scheduleTime.length > 0) {
        this.scheduleForm.startDatetime = this.scheduleTime[0]
        this.scheduleForm.endDatetime = this.scheduleTime[1]
      }

      let noeDate = this.$common.parseTime(new Date(), '{y}-{m}-{d}')

      this.scheduleForm.ext1 = this.scheduleDate ? this.scheduleDate : noeDate
      let method = "saveSchedule"
      if (this.scheduleForm.scheduleId) {
        method = 'updateSchedule'
      }

      this.$refs['scheduleForm'].validate(vaild => {
        if (vaild) {
          this.$api.workbench[method](this.scheduleForm).then(res => {
            if (res.success) {
              let tips = "创建日程成功"
              if (this.scheduleForm.scheduleId) {
                tips = '日程修改成功'
              }
              this.$message.success(tips)
              this.handleClose()
              this.getScheduleList()
            } else {
              this.$message.error(res.message)

            }
          })
        }
      })
    },

    // 日程列表
    getScheduleList() {
      this.scheduleList = []
      let param = {
        day: this.scheduleDate ? this.scheduleDate : this.$common.parseTime(new Date(), '{y}-{m}-{d}')
      }
      this.$api.workbench.getScheduleList(param).then(res => {
        this.scheduleFlag = false
        if (res.success) {
          this.scheduleList = res.result
        }
      }).catch(err => {
        this.scheduleFlag = false
      })
    },

    // 获取天气
    getWeather() {
      // var mydate = new Date()
      // var myday = mydate.getDay()
      // switch (myday) {
      //   case 0: this.week = "Sunday"; break;
      //   case 1: this.week = "Monday"; break;
      //   case 2: this.week = "Tuesday"; break;
      //   case 3: this.week = "Wednesday"; break;
      //   case 4: this.week = "Thursday"; break;
      //   case 5: this.week = "Friday"; break;
      //   case 6: this.week = "Saturday"; break;
      //   default: this.week = "系统错误！"
      // }

      this.$http.get('api/weather').then((res) => {
        if (res.success) {
          let result = res.result
          this.humidityInfo = result.humidityInfo
          this.humidity = result.humidity

          this.realTemp = result.realTemp
          this.feelTemp = result.feelTemp
          this.direct = result.direct
          this.power = result.power
          this.weatherImg = require(`@/assets/weatherIcon/${result.weather}.png`)
          this.weatherInfo = result.weatherInfo
          this.minTemp = result.minTemp
          this.maxTemp = result.maxTemp
          this.week
        }
      })
    },
    // 藏品饼图
    setCulturalPieOptions() {

      this.$api.workbench.getPieOptions().then(res => {
        if (res.success) {
          if (res.result && res.result.result) {
            let results = res.result.result
            this.collectionNum = results.total
            if (results.pie && results.pie.length > 0) {
              let pieArr = []
              results.pie.map(item => {
                let arr = this.levelList.filter(it => {
                  return it.dictCode == item.collect_level
                })
                pieArr.push({
                  value: item.total,
                  name: arr && arr.length > 0 ? arr[0].dictName : item.collect_level
                })

                this.pieLegend.push({
                  name: arr && arr.length > 0 ? arr[0].dictName : item.collect_level,
                  num: item.total
                })
              })
              this.$nextTick(() => {
                let chart = this.$echarts.init(this.$refs.chart2);
                var opt = {
                  tooltip: {
                    trigger: 'item'
                  },
                  color: this.colors,
                  series: [
                    {
                      type: 'pie',
                      radius: ['45%', '80%'],
                      avoidLabelOverlap: false,
                      itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                      },
                      label: {
                        show: false,
                        position: 'center'
                      },
                      emphasis: {
                        label: {
                          show: true,
                        }
                      },
                      labelLine: {
                        show: false
                      },
                      data: pieArr
                    }
                  ]
                };
                chart.setOption(opt);
                window.addEventListener("resize", function () {
                  chart.resize();
                });
              })
            }
          }
        }
      })
    },

    setTourOptions(type) {
      this.$api.workbench.getTourRecord({ type: type }).then(res => {
        if (res.success) {
          let result = res.result
          if (result.currentTxt) {
            let obj = {
              text: result.currentTxt,
              num: result.currentNum || 0
            }
            this.tourList.push(obj)
          }
          if (result.compareTxt) {
            let obj = {
              text: result.compareTxt,
              num: result.compareNum || 0
            }
            this.tourList.push(obj)
          }
          if (result.totalTxt) {
            let obj = {
              text: result.totalTxt,
              num: result.totalNum || 0
            }
            this.tourList.push(obj)
          }
          if (result.option) {
            let option = result.option
            if (option.series && option.series.length > 0) {
              this.tourFlag = option.series.some(item => {
                return Object.keys(item.data).length > 0
              })
            } else {
              this.tourFlag = false
            }

            if (!this.tourFlag) {
              return
            }

            this.$nextTick(() => {
              let chart = this.$echarts.init(this.$refs.chart3)

              var opt = {
                xAxis: {
                  type: "category",
                  axisTick: { //y轴刻度线
                    show: false
                  },
                  axisLine: { //y轴
                    show: false
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: '#E6E6E6',
                    }
                  },
                  nameTextStyle: {
                    color: "#CECECE"
                  },
                  data: option.xAxis.data
                },
                legend: {
                  show: true,
                  icon: 'circle',
                  align: 'left',
                },
                tooltip: {
                  show: true,
                  trigger: 'axis'
                },
                color: ['#225C81', '#A3463F', '#F3CC89'],
                grid: { left: 55, top: 30, right: 10, bottom: 20 },
                yAxis: {
                  type: 'value',
                  splitLine: {
                    lineStyle: {
                      color: '#E6E6E6',
                    }
                  },
                  axisTick: { //y轴刻度线
                    show: false
                  },
                  axisLine: { //y轴
                    show: false
                  },
                },
                series: option.series
              };

              chart.setOption(opt);
              window.addEventListener("resize", function () {
                chart.resize();
              });
            })
          }

        }
      })
    },

    // 社交活动
    changeActivity(type) {
      this.activityFlag = false
      if (type == 1) {
        this.getCount('getAactivityCount')
      } else if (type == 2) {
        this.getCount('getPeopleCount')
      } else {
        this.getCount('getServiceCount')
      }
    },

    changeTour(type) {
      this.$nextTick(() => {
        this.tourFlag = false
        this.tourList = []
        this.setTourOptions(type)
      })
    },

    getCount(url) {
      let xAxis = [], series = []
      this.$api.workbench[url]().then(res => {
        if (res.success) {

          if (res.result) {
            xAxis = res.result.x
            series = res.result.series
            if (series && series.length > 0) {
              this.activityFlag = true
              this.$nextTick(() => {
                this.setActivityOptions(xAxis, series)
              })
            } else {
              this.activityFlag = false
            }
          }
        }
      })
    },

    // 社交活动折线图
    setActivityOptions(xAxis, data) {
      let chart = this.$echarts.init(this.$refs.chart4),
        series = []
      if (data[0]) {
        series.push({
          name: '讲座',
          data: data[0],
          type: 'line',
          lineStyle: {
            width: 3
          },
          smooth: true
        })
      }

      if (data[1]) {
        series.push({
          name: '青少年活动',
          data: data[1],
          type: 'line',
          lineStyle: {
            width: 3
          },
          smooth: true
        })
      }

      if (data[2]) {
        series.push({
          name: '小讲解员',
          data: data[2],
          type: 'line',
          lineStyle: {
            width: 3
          },
          smooth: true
        })
      }

      if (data[3]) {
        series.push({
          name: '流动文化服务',
          data: data[3],
          type: 'line',
          lineStyle: {
            width: 3
          },
          smooth: true
        })
      }

      if (data[4]) {
        series.push({
          name: '场馆活动',
          data: data[4],
          type: 'line',
          lineStyle: {
            width: 3
          },
          smooth: true
        })
      }
      var opt = {
        xAxis: {
          type: "category",
          axisTick: { //y轴刻度线
            show: false
          },
          axisLine: { //y轴
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E6E6E6',
            }
          },
          nameTextStyle: {
            color: "#CECECE"
          },
          data: xAxis
        },
        legend: {
          show: true,
          bottom: 16,
          icon: "circle",
          // formatter: function (name) {
          //   var data = opt.series,
          //     total = 0

          //   for (var i = 0; i < data.length; i++) {
          //     for (let j = 0; j < data[i].data.length; j++) {
          //       if (name == data[i].name) {
          //         total += parseInt(data[i].data[j]);
          //       }
          //     }
          //   }

          //   return `${name}  ${total}`;

          // }
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        grid: { left: 40, top: 20, right: 10, bottom: 80 },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#E6E6E6',
            }
          },
          axisTick: { //y轴刻度线
            show: false
          },
          axisLine: { //y轴
            show: false
          },
        },
        series: series
      };

      chart.setOption(opt);
      window.addEventListener("resize", function () {
        chart.resize();
      });
    },

    // 陈列展览折线图
    setExhibitionOptions() {
      this.exhibitionFlag = false
      let xAxis = [], series = []
      this.$api.workbench.getExhibitionOptions().then(res => {
        if (res.success) {
          if (res.result) {
            xAxis = res.result.x
            series = res.result.series
            if (series && series.length > 0) {
              this.exhibitionFlag = true
              this.$nextTick(() => {
                let chart = this.$echarts.init(this.$refs.chart5);
                var opt = {
                  xAxis: {
                    type: "category",
                    axisTick: { //y轴刻度线
                      show: false
                    },
                    axisLine: { //y轴
                      show: false
                    },
                    splitLine: {
                      show: true,
                      lineStyle: {
                        color: '#E6E6E6',
                      }
                    },
                    nameTextStyle: {
                      color: "#CECECE"
                    },
                    data: xAxis
                  },

                  legend: {
                    show: true,
                    bottom: 16,
                    icon: "circle",
                    // formatter: function (name) {
                    //   var data = opt.series,
                    //     total = 0

                    //   for (var i = 0; i < data.length; i++) {
                    //     for (let j = 0; j < data[i].data.length; j++) {
                    //       if (name == data[i].name) {
                    //         total += parseInt(data[i].data[j]);
                    //       }
                    //     }
                    //   }

                    //   return `${name}  ${total}`;

                    // }
                  },
                  tooltip: {
                    show: true,
                    trigger: 'axis'
                  },
                  color: ['#3C4059', '#82B29A', '#F3CC89'],
                  grid: { left: 40, top: 20, right: 10, bottom: 80 },
                  yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitLine: {
                      lineStyle: {
                        color: '#E6E6E6',
                      }
                    },
                    axisTick: { //y轴刻度线
                      show: false
                    },
                    axisLine: { //y轴
                      show: false
                    },
                  },
                  series: [
                    {
                      name: '常设展览',
                      data: series[0],
                      type: 'line',
                      lineStyle: {
                        width: 3
                      },
                      smooth: true
                    },
                    {
                      name: '临时展览',
                      data: series[1],
                      type: 'line',
                      lineStyle: {
                        width: 3
                      },
                      smooth: true
                    },
                  ]
                };

                chart.setOption(opt);
                window.addEventListener("resize", function () {
                  chart.resize();
                });
              })
            } else {
              this.exhibitionFlag = false
            }
          }
        }
      })
    },

    // 展览列表
    getExhibitionList() {
      this.lszlList = []
      this.clzlList = []
      let params = {
        year: new Date().getFullYear()
      }
      this.$api.workbench.getExhibitionList(params).then(res => {
        if (res.success) {
          if (res.result) {
            if (res.result.clzl && res.result.clzl.length > 0) {
              this.clzlList = res.result.clzl
            }

            if (res.result.lszl && res.result.lszl.length > 0) {
              this.lszlList = res.result.lszl
            }
          }
        }
      })
    },

    // 信息发布列表
    getInfoList() {
      this.$http.get('/bsInformation/commonList', {
        type: '1',
        currentPage: 1,
        size: 5
      }).then(res => {
        this.isLoading = false
        if (res.success) {
          this.infoList = res.result
        }
      })
    },

    // 待办事项数据
    getTodoList() {
      if (this.pageType == 'pending') {
        this.$store.dispatch('updataSiderbarCount')
      }
      this.$http.post('/workflowActvity/list', {
        action: "1",
        currentPage: 1,
        size: 10
      }).then(res => {
        if (res.success) {
          if (res.result && res.result.data) {
            this.approveList = res.result.data
          }
          this.approveNum = res.page.allRow
        }
      })

      this.$http.post('/workflowActvity/list', {
        action: "0",
        currentPage: 1,
        size: 10
      }).then(res => {
        if (res.success) {
          if (res.result && res.result.data) {
            this.approveByMineList = res.result.data
          }
          this.approveByMeNum = res.page.allRow
        }
      })

      // 项目进度
      this.$http.get('/project/projectStatistics', {}).then(res => {
        if (res.success) {
          if (res.result && res.result.length > 0) {
            let project = res.result
            project.map(item => {
              item.percent = parseInt(item.percent.slice(0, -1))
            })

            this.proList = project
          }
        }
      })
    },

    getDynamicDataList() {
      this.listLoading = true
      this.$http.get('/wkDynamic/list', {
        ...this.listQuery
      })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.showBtn = res.others
            for (let i = 0; i < res.result.length; i++) {
              res.result[i].isTotal = false
              if (this.userid == res.result[i].creater) {
                res.result[i].isDelete = 1
              }
            }
            if (this.listQuery.currentPage === 1) {
              this.noMore = false
              this.dynamicDataList = res.result
            } else {
              if (res.result.length < this.listQuery.size) {
                this.noMore = true
              }
              this.dynamicDataList = this.dynamicDataList.concat(res.result)
            }
          } else {
            this.$message.error(res.message)
          }
          console.log(this.dynamicDataList)
        })
        .catch(() => {
          this.listLoading = false
        })
    },

    // 加载更多动态
    moreDynamic() {
      this.listQuery.currentPage += 1
      this.getDynamicDataList()
    },

    refreshDynamic(type, dynamicId) {
      // 1发动态 2评论 3回复
      if (type === '1') {
        this.listQuery.currentPage = 1
        this.getDynamicDataList()
      } else {
        let _dynamic = this.dynamicDataList.find(
          item => item.dynamicId === dynamicId
        )

        this.$http
          .get('/wkDynamic/listComment', {
            dynamicId: dynamicId
          })
          .then(res => {
            if (res.success) {
              _dynamic.commentList = res.result
            } else {
              this.$message.error(res.message)
            }
          })
      }
    },

    // 添加/取消点赞
    changeLike(item) {
      this.$http
        .post('/wkDynamic/praise', {
          dynamicId: item.dynamicId
        })
        .then(res => {
          if (res.success) {
            // 1，未点赞 2，已点赞
            this.$message.success(
              item.status === '2' ? '取消点赞成功' : '点赞成功'
            )
            item.status = item.status === '2' ? '1' : '2'
            // 更新点赞人数
            item.praise = res.result.praise
          } else {
            this.$message.error(
              res.message || (item.status === '2' ? '取消点赞失败' : '点赞失败')
            )
          }
        })
    },

    // 评论
    handleComment(item) {
      this.$refs.dialogCreadDynamic.init('2', item.dynamicId)
    },

    handleOperate(item, commentId, type) {
      if (type === '1') {
        // 回复
        this.$refs.dialogCreadDynamic.init('3', item.dynamicId, commentId)
      } else if (type === '2') {
        this.$common.confirm(
          {
            title: '确定删除评论吗？',
            className: 'cus-confirm-375'
          },
          () => {
            this.$http
              .post('/wkDynamic/delComment', {
                commentId: commentId
              })
              .then(res => {
                if (res.success) {
                  this.$message.success('删除评论成功')
                  item.commentList = item.commentList.filter(
                    row => row.commentId !== commentId
                  )
                } else {
                  this.$message.error(res.message)
                }
              })
          }
        )
      }
    },



  },

  mounted() {
    this.userid = this.$store.state.user.userid
    this.getDict()
    // 获取天气信息
    this.getWeather()
    this.getInfoList()
    // 审批和项目进度
    this.getTodoList()
    // 线下参观客流
    this.setTourOptions()
    // 部门动态
    this.getDynamicDataList()
    // 获取社交活动
    this.changeActivity(1)
    // 获取陈列展览
    this.setExhibitionOptions()
    this.getExhibitionList()
    // 获取藏馆文物
    this.setCulturalPieOptions()
    // 获取日程列表
    this.getScheduleList()

    this.getAttendance()
  }

}
</script>

<style lang="scss" scoped>
.work-bench {
  height: calc(100vh - 80px);
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  .bg {
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
  }
  /deep/.el-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 10px;
    .el-card__header {
      padding: 10px 19px 13px 16px;
      border-bottom: none;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    .el-card__body {
      position: relative;
      flex: 1;
      height: 0;
      padding: 0 10px 16px;
    }

    .el-tabs {
      .el-tabs__header {
        margin-bottom: 10px;
        padding-left: 6px;
      }
      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }
      }
      .el-tabs__active-bar {
        display: none;
      }
      .el-tabs__item {
        height: 15px;
        line-height: 15px;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        &.is-active {
          font-weight: bold;
          color: $color1;
        }
      }
    }

    .card-content {
      .title-wrapper {
        flex: 1;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-weight: 500;
        color: rgba(102, 102, 102, 0.7);
        .span-title {
          width: 0;
          flex: 1;
          margin-right: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-left: 10px;
          &:before {
            content: '';
            display: inline-block;
            vertical-align: top;
            position: relative;
            top: 5px;
            width: 6px;
            height: 6px;
            margin-right: 10px;
            border-radius: 50%;
            background: rgba(102, 102, 102, 0.7);
          }
        }

        .span-time {
          flex-shrink: 0;
          padding-right: 10px;
        }
      }
      .el-collapse {
        border: none;
        .el-collapse-item {
          .el-collapse-item__header {
            height: 30px;
            line-height: 30px;
            border: none;
          }

          .el-collapse-item__wrap {
            border: none;
            .el-collapse-item__content {
              padding-bottom: 4px;
              .el-progress-bar__outer {
                background-color: #f7f7f7;
                .el-progress-bar__inner {
                  &:last-child {
                    .el-progress-bar__innerText {
                      color: #b6b6b6 !important;
                    }
                  }
                }
              }
              // .el-progress-bar__innerText{
              //   color: #B6B6B6 !important;
              // }
            }
            .el-progress-bar__outer {
              height: 26px !important;
            }
          }

          .el-collapse-item__arrow {
            margin-left: 0 !important;
            margin-right: 5px !important;
            font-size: 20px;
          }
        }
      }
    }
  }
  .left {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin-right: 15px;
    .left-top {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-content: center;
      padding: 12px 43px 11px 40px;
      margin-bottom: 14px;
      .part {
        display: flex;
        cursor: pointer;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        .t-c {
          text-align: center;
          img {
            width: 41px;
            height: 41px;
          }
        }
        .mt-15 {
          color: #333333;
          margin-top: 10px;
          line-height: 14px;
        }
      }
    }

    .left-middle {
      display: flex;
      height: 0;
      flex: 1;
      margin-bottom: 17px;
      .news-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        margin-right: 16px;

        .mb-13 {
          margin-bottom: 13px;
        }

        .approve-wrapper {
          flex: 1;
          height: 0;
          /deep/ .el-progress-bar__inner {
            background: linear-gradient(270deg, #306b91, #549ac6);
          }
          .img-add {
            width: 20px;
            height: 20px;
            margin-top: 2px;
            cursor: pointer;
          }

          .more {
            position: absolute;
            cursor: pointer;
            top: 6.4px;
            right: 10px;
            color: $color1;
            font-size: 14px;
          }
          /deep/.el-tabs {
            height: 100%;
            display: flex;
            flex-direction: column;
            .el-tabs__content {
              overflow: auto;
            }
          }
          .approve-ul {
            margin-left: 6px;
            .approve-li {
              cursor: pointer;
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              height: 30px;
              line-height: 30px;
              background: rgba(247, 247, 247, 0.8);
              padding-left: 7px;
              margin-bottom: 7px;
            }
          }
        }
      }

      .dynamic-wrapper {
        width: 334px;
        height: 100%;
        .img-add {
          width: 20px;
          height: 20px;
          margin-top: 2px;
          cursor: pointer;
        }

        /deep/ .el-card__body {
          overflow: auto;
        }
        .box-dynamic {
          overflow-y: auto;
          box-sizing: border-box;
          .dynamic-item {
            &:first-child {
              padding-top: 7px !important;
            }
            padding: 20px 20px;
            border-bottom: solid 1px $border;
          }
          .top {
            position: relative;
            height: 25px;
            // padding: 0 32px;
            display: flex;
            justify-content: space-between;
            .avatar-wrapper {
              display: flex;
              .avatar {
                width: 25px;
                height: 25px;
                border-radius: 100%;
              }
              .des {
                margin-left: 7px;
                .name {
                  font-size: 16px;
                  color: #333333;
                  line-height: 25px;
                  span.tag {
                    font-size: 12px;
                    color: $color6;
                  }
                }
                .time {
                  margin-top: 10px;
                  font-size: 12px;
                  color: $color6;
                  line-height: 12px;
                  .dele {
                    color: #d0be88;
                    margin-left: 10px;
                  }
                }
              }
            }
            .delete {
              i {
                color: red;
                cursor: pointer;
              }
            }
            .cmp-icon-like {
              display: block;
              background: url('~@images/zan.svg') center center no-repeat;
              background-size: 100%;
              position: absolute;
              width: 20px;
              height: 20px;
              top: 10px;
              right: 0;
              cursor: pointer;
            }

            .cmp-icon-like.active {
              background: url('~@images/zan-active.svg') center center no-repeat;
              background-size: 100% 100%;
            }
          }

          .detail {
            font-size: 12px;
            color: #333;
            line-height: 20px;
            .tag-total {
              margin-top: 10px;
              font-size: 14px;
              color: $color1;
              line-height: 30px;
              cursor: pointer;
            }
          }
          .img-list {
            img {
              width: 60px;
              height: 60px;
              object-fit: cover;
              margin-bottom: 10px;
            }
          }
          .btns {
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: #9f9fa1;

            .delete {
              margin-left: 10px;
              cursor: pointer;
              color: #306159;
            }
            .right1 {
              display: flex;
              align-items: center;
              .cmp-like {
                position: relative;
                top: -2px;
                .cmp-icon-like {
                  display: block;
                  background: url('~@images/zan.svg') center center no-repeat;
                  background-size: 100%;
                  width: 20px;
                  height: 20px;
                  cursor: pointer;
                  &.active {
                    background: url('~@images/zan-active.svg') center center
                      no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
              .btn-comment {
                cursor: pointer;
                img {
                  width: 20px;
                }
              }
            }
          }
          .bottom {
            padding: 5px 0;
            position: relative;
            width: 100%;
            background: #f5f5f5;
            .trangle {
              position: absolute;
              top: -5px;
              left: 20px;
              width: 0;
              height: 0;
              border-left: solid 5px transparent;
              border-right: solid 5px transparent;
              border-bottom: solid 5px #f3f3f3;
            }
            .person-box {
              padding: 0 10px;
              &.has-comment {
                margin-bottom: 5px;
                padding-bottom: 5px;
                border-bottom: solid 1px #e7e7e7;
              }
              img {
                margin-right: 8px;
                margin-top: 2px;
                width: 16px;
                height: 16px;
              }
              label {
                display: inline-block;
                // width: 380px;
                width: calc(100% - 40px);
                color: #909090;
                font-size: 14px;
              }
            }

            ul.comment-list {
              li {
                padding: 0 10px;
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                line-height: 24px;
                .light {
                  color: #576a95;
                }
                .icon-common {
                  display: none;
                }
                &:hover {
                  background: #d8d8d8;
                  .icon-common {
                    display: inline-block;
                  }
                }
              }
            }
          }
        }
      }
    }

    .left-bottom {
      height: 270px;
      display: flex;
      flex-direction: row;
      .box-process {
        margin-right: 16px;
        /deep/.el-card__body {
          overflow: auto;
        }

        .progress-wrapper {
          margin-bottom: 9px;
          display: flex;
          .progress-inner {
            position: relative;
            flex: 1;
            .pro-box {
              width: 100%;
              margin-right: -74px;
              padding-right: 74px;
              position: absolute;
              // top: 6px;
              top: 14px;
              left: 10px;
              .pro-name {
                width: 100%;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                font-weight: 600;
                color: #333333;
              }
              .pro-type {
                font-size: 12px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.5);
              }
            }
          }

          .day-wrapper {
            flex-basis: 112px;
            font-size: 12px;
            text-align: center;
            font-weight: 400;
            color: #999999;
            padding-top: 6px;
            margin-left: 10px;
            background: rgb(247, 247, 247);
            border-radius: 10px;
            .day-content {
              color: #333333;
              font-size: 20px;
              padding-right: 13px;
            }
          }
          /deep/.el-progress {
            .el-progress-bar {
              margin-right: -74px;
              padding-right: 74px;
              border-radius: 10px;
              background: rgb(247, 247, 247);
              .el-progress-bar__outer {
                height: 50px !important;
                background: transparent;
                border-radius: 10px;
                .el-progress-bar__inner {
                  background: #d9ece6;
                  border-radius: 10px;
                }
              }
            }

            .el-progress__text {
              font-size: 20px !important;
              font-weight: 400;
              color: #333333;
            }
          }
        }
      }
      .box-museum {
        width: 0;
        flex-basis: 334px;
        flex-shrink: 0;
        .chart-wrapper {
          width: 100%;
          height: 140px;
          display: flex;
          flex-direction: row;
          .pie-chart {
            flex: 1;
            height: 140px;
          }

          .total {
            flex-basis: 134px;
            background: #f7f7f7;
            padding: 24px 0 0 15px;
            border-radius: 10px;
            img {
              width: 32px;
            }
            .p1 {
              margin: 15px 0 10px;
              font-size: 12px;
              font-weight: 400;
              color: #777777;
            }

            .p2 {
              font-size: 26px;
              font-weight: bold;
              color: #333333;
            }
          }
        }

        .chart-legend {
          display: flex;
          flex-wrap: wrap;
          .legend-item {
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 7px;
            .legend-item-inner {
              width: 100%;
              height: 20px;
              line-height: 20px;
              font-size: 0;
              margin-left: 40px;
              span {
                display: inline-block;
                font-size: 14px;
                font-weight: 600;
                color: #333333;
                &:first-child {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  margin-right: 8px;
                }
                &:last-child {
                  margin-left: 13px;
                }
              }
            }
          }
        }
      }
    }
  }

  .right {
    flex: 1;
    flex-shrink: 0;
    display: flex;
    height: 100%;
    box-sizing: border-box;
    .chart-wrapper {
      display: flex;
      width: 492px;
      flex-direction: column;
      margin-right: 15px;
      .chart1 {
        height: 100%;
        /deep/ .el-card__header {
          padding-bottom: 7px;
        }

        /deep/ .el-select {
          width: 120px;
          .el-input {
            font-size: 12px;
            font-weight: 400;
            color: #333333;

            .el-input__inner {
              padding-right: 45px;
              text-align: right;
              font-weight: 600;
              height: 30px;
              line-height: 30px;
              border: none;
            }

            .el-select__caret {
              &::before {
                content: '';
                background: url(../../assets/images/iconkemu.png) center center
                  no-repeat;
                position: absolute;
                width: 20px;
                height: 20px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }
        }

        .chart-info {
          display: flex;
          position: absolute;
          bottom: 16px;
          left: 10px;
          right: 10px;
          .chart-item {
            height: 63px;
            box-sizing: border-box;
            padding: 10px 12px 14px;
            flex: 1;
            background: #f7f7f7;
            border-radius: 10px;
            .span1 {
              display: block;
              line-height: 14px;
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              margin-bottom: 10px;
            }

            .span2 {
              display: block;
              font-size: 20px;
              font-weight: 400;
              color: #414141;
              line-height: 18px;
            }
          }
        }
      }

      .chart2 {
        .chart-flex {
          display: flex;
          height: 100%;
          .exhibition-chart {
            height: 100%;
            flex: 1;
          }

          .exhibition-des {
            height: 100%;
            overflow: auto;
            flex-basis: 150px;
            flex-shrink: 0;
            h1 {
              margin-bottom: 9px;
              font-size: 14px;
              font-weight: 600;
              color: #333333;
            }

            p {
              width: 150px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
              line-height: 20px;
              font-weight: 400;
              color: #222222;
            }
          }
        }
      }

      .kl-box {
        margin-bottom: 13px;
        flex: 1;
      }

      .sj-box {
        margin-bottom: 17px;
        height: 255px;
      }

      .zl-box {
        height: 270px;
      }
    }

    .others {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 0;
      .weather-wrapper {
        background: url(../../assets/images/workbench/weather-bg.png) no-repeat
          center;
        padding: 10px 15px 10px 17px;
        .weather-inner {
          display: flex;
          justify-content: space-between;
          font-size: 0;
          font-weight: 400;
          color: #ffffff;
          .weather-left {
            .tem {
              padding-top: 5px;
              line-height: 31px;
              display: block;
              font-size: 40px;
              font-weight: 400;
              margin-bottom: 16px;
            }
            .date {
              font-size: 16px;
              text-align: center;
              padding: 2px 12px;
              background: #3788ba;
              border-radius: 10px;
              &.green {
                background-color: #5f987f;
              }

              &.yellow {
                background-color: #fcd54b;
              }

              &.orange {
                background-color: #fe9a57;
              }

              &.red {
                background-color: #fd6a69;
              }

              &.purple {
                background-color: #a979bb;
              }

              &.maroon {
                background-color: #a87383;
              }
            }
          }

          .weather-right {
            span {
              display: block;
              text-align: right;
              &.weather-img {
                margin-bottom: 7px;
                img {
                  width: 40px;
                  height: 40px;
                }
              }
              &.week {
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                margin-bottom: 6px;
              }

              &.tem-range {
                font-size: 12px;
              }
            }
          }
        }

        .weather-detail {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          .detail-part {
            flex: 1;
            background: rgba(247, 247, 247, 0.2);
            border-radius: 10px;
            padding: 4px 5px;
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            .detail-top {
              img {
                width: 16px;
                height: 16px;
              }
            }

            .detail-bottom {
              padding-left: 4px;
              font-size: 18px;
            }
          }
        }
      }

      .schedule-wrapper {
        height: 0;
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
        /deep/.wh_container {
          .wh_top_changge {
            li {
              color: #000000;
              .wh_jiantou1,
              .wh_jiantou2 {
                border-color: #000000;
              }
            }
          }
          .wh_content_all {
            background: #ffffff;
            border-radius: 10px 10px 0 10px;
            .wh_content {
              display: flex;
            }
            .wh_content_item {
              color: #000000;
              width: calc(100% / 7);
              height: 30px;
              .wh_top_tag {
                width: 30px;
                height: 30px;
              }
              .wh_item_date {
                width: 30px;
                height: 30px;
                &:hover {
                  border-radius: 50%;
                  background: #306159;
                  color: #fff;
                }
              }
              .wh_isToday {
                color: #306159;
                background: transparent;
                border: 2px solid #306159;
                &.wh_chose_day {
                  &::after {
                    background: #fff;
                  }
                }
                &:hover {
                  &::after {
                    background: #fff;
                  }
                }
                &::after {
                  content: '';
                  position: absolute;
                  bottom: 2px;
                  left: 50%;
                  transform: translateX(-50%);
                  display: inline-block;
                  width: 4px;
                  height: 4px;
                  border-radius: 50%;
                  background: #306159;
                }
              }

              .wh_chose_day {
                background: #306159;
                color: #fff;
              }
            }
          }
        }

        .schedule-inner {
          flex: 1;
          height: 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          .img-add {
            width: 20px;
            height: 20px;
            margin-top: 2px;
            cursor: pointer;
          }
          .header {
            display: flex;
            justify-content: space-between;
            padding: 0 14px;
            font-size: 18px;
            font-weight: bold;
            color: #333333;
          }

          .schedule-list {
            flex: 1;
            overflow: auto;
            padding: 6px 0 12px;
            .schedule-item {
              display: flex;
              cursor: pointer;
              height: 62px;
              padding: 0 18px;
              margin-bottom: 8px;
              &:last-child {
                margin-bottom: 0;
              }
              .line {
                display: inline-block;
                width: 5px;
                height: 62px;
                border-radius: 3px;
                background: #306159;
              }
              .schedule-inner-right {
                width: 0;
                flex: 1;
                border-radius: 10px;
                background: #f7f7f7;
                .schedule-top {
                  margin-left: 12px;
                  padding: 7px 0;
                  font-size: 14px;
                  font-weight: 400;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .span1 {
                    vertical-align: middle;
                    color: #333333;
                    line-height: 20px;
                    margin-right: 15px;
                  }
                  .span2 {
                    vertical-align: middle;
                    line-height: 20px;
                    color: #306159;
                  }

                  .icon {
                    color: $primary;
                    font-size: 20px;
                    font-weight: bold;
                    padding-right: 10px;
                  }
                }
                .schedule-bottom {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-left: 12px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #aaaaaa;
                }
              }
            }
          }
        }
      }

      .attendance-wrapper {
        display: flex;
        flex-direction: column;
        padding: 0 16px;
        height: 174px;
        .header {
          padding: 14px 0;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
        .content {
          display: flex;
          justify-content: space-between;
          .part {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            background: rgba(59, 194, 98, 0);
            border: 1px solid #e0e0e0;
            border-radius: 5px;
            margin-right: 15px;
            &:last-child {
              margin-right: 0;
            }
            .part-day {
              width: 100%;
              text-align: center;
              font-size: 37px;
              font-weight: bold;
              color: #333333;
              border-bottom: 1px solid #e0e0e0;
              .span1 {
                font-size: 10px;
                font-weight: 300;
                color: #777777;
              }
            }

            .part-desc {
              padding: 10px 0;
              font-size: 12px;
              font-weight: 400;
              color: #656565;
            }
          }
        }
      }
    }
  }
  /deep/ .el-date-editor {
    width: 100%;
  }
}
@media (min-width: 1920px) {
  // /deep/.wh_container {
  //   .wh_content_all {
  //     .wh_content_item {
  //       height: 24px !important;
  //       .wh_top_tag {
  //         width: 24px !important;
  //         height: 24px !important;
  //       }
  //       .wh_item_date {
  //         width: 24px !important;
  //         height: 24px !important;
  //       }
  //     }
  //   }
  // }
}
</style>